import React from 'react';

export const DOCS = {
  termos:        { file: '01_KiAluga_Termos_e_Condicoes.pdf',          titulo: 'Termos e Condições de Uso' },
  privacidade:   { file: '02_KiAluga_Politica_Privacidade.pdf',        titulo: 'Política de Privacidade' },
  cookies:       { file: '03_KiAluga_Politica_Cookies.pdf',            titulo: 'Política de Cookies' },
  contrato:      { file: '04_KiAluga_Contrato_Utilizador_Fornecedor.pdf', titulo: 'Contrato de Utilizador e Fornecedor' },
  escrow:        { file: '05_KiAluga_Politica_Escrow_Pagamentos.pdf',  titulo: 'Política de Escrow e Pagamentos' },
  caucao:        { file: '06_KiAluga_Politica_Caucao.pdf',             titulo: 'Política de Caução' },
  cancelamento:  { file: '07_KiAluga_Politica_Cancelamento_Reembolso.pdf', titulo: 'Política de Cancelamento e Reembolso' },
  disputas:      { file: '08_KiAluga_Politica_Resolucao_Disputas.pdf', titulo: 'Política de Resolução de Disputas' },
  kyc:           { file: '09_KiAluga_Politica_KYC.pdf',                titulo: 'Política de KYC e Verificação de Identidade' },
  danos:         { file: '10_KiAluga_Politica_Danos_Perdas.pdf',       titulo: 'Política de Danos e Perdas' },
  faq:           { file: '11_KiAluga_FAQ.pdf',                         titulo: 'Perguntas Frequentes (FAQ)' },
  guiaFornecedor:{ file: '12_KiAluga_Guia_Fornecedor.pdf',             titulo: 'Guia do Fornecedor' },
  guiaCliente:   { file: '13_KiAluga_Guia_Cliente.pdf',                titulo: 'Guia do Cliente' },
};

export default function DocModal({ docKey, onClose }) {
  const doc = DOCS[docKey];
  if (!doc) return null;

  const url = `${process.env.PUBLIC_URL}/docs/${doc.file}`;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px',
    }} onClick={onClose}>
      <div style={{
        background: '#0d1b2e', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '16px', width: '100%', maxWidth: '860px',
        height: '90vh', display: 'flex', flexDirection: 'column',
        overflow: 'hidden',
      }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 18px', borderBottom: '1px solid rgba(255,255,255,0.08)',
          flexShrink: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: '28px', height: '28px', background: '#F97316', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '800', fontSize: '14px', color: '#fff', fontFamily: 'Syne,sans-serif' }}>K</div>
            <span style={{ fontSize: '14px', fontWeight: '600', color: '#fff', fontFamily: 'Plus Jakarta Sans,sans-serif' }}>{doc.titulo}</span>
          </div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <a href={url} download={doc.file} style={{ fontSize: '12px', color: '#F97316', textDecoration: 'none', padding: '6px 12px', border: '1px solid rgba(249,115,22,0.3)', borderRadius: '8px', fontFamily: 'Plus Jakarta Sans,sans-serif' }}>
              ↓ Download
            </a>
            <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.07)', border: 'none', color: 'rgba(255,255,255,0.6)', width: '30px', height: '30px', borderRadius: '8px', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
          </div>
        </div>

        {/* PDF Viewer */}
        <iframe
          src={url}
          title={doc.titulo}
          style={{ flex: 1, border: 'none', width: '100%', background: '#fff' }}
        />
      </div>
    </div>
  );
}

export function DocLink({ docKey, children, style }) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <span
        onClick={() => setOpen(true)}
        style={{ color: '#F97316', cursor: 'pointer', textDecoration: 'underline', ...style }}
      >
        {children || DOCS[docKey]?.titulo}
      </span>
      {open && <DocModal docKey={docKey} onClose={() => setOpen(false)} />}
    </>
  );
}
